import { Close as CloseIcon } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";

interface DeletableChipProps {
  label: string;
  onDelete: () => void;
  size?: "small" | "medium";
  maxChars?: number;
  tooltip?: string;
}

const DeletableChip: React.FC<DeletableChipProps> = ({
  label,
  onDelete,
  size = "small",
  maxChars,
  tooltip,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const height = size === "small" ? "24px" : "32px";
  const fontSize = size === "small" ? "0.75rem" : "0.875rem";
  const iconSize = size === "small" ? "14px" : "18px";

  // Truncate label if maxChars is specified
  const displayLabel =
    maxChars && label.length > maxChars
      ? `${label.substring(0, maxChars)}...`
      : label;

  const chipContent = (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDelete();
      }}
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#1976d2",
        color: "#fff",
        borderRadius: "12px",
        height,
        paddingX: "8px",
        margin: "3px 4px 3px 0",
        cursor: "pointer",
        fontSize,
        fontWeight: 500,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "#666",
        },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize,
          fontWeight: 500,
          color: "#fff",
          opacity: isHovered ? 0.3 : 1,
          transition: "opacity 0.2s ease-in-out",
          userSelect: "none",
        }}
      >
        {displayLabel}
      </Typography>

      {isHovered && (
        <CloseIcon
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: iconSize,
            color: "#fff",
            opacity: 1,
            transition: "opacity 0.2s ease-in-out",
            "&:hover": {
              color: "#ffcccb",
            },
          }}
        />
      )}
    </Box>
  );

  return tooltip ? (
    <Tooltip title={tooltip} arrow placement="top">
      {chipContent}
    </Tooltip>
  ) : (
    chipContent
  );
};

export default DeletableChip;
